import { createContext, createElement, useContext, useMemo, useState } from 'react'
import { SaveIndicatorStatus } from '../components/save-indicator/save-indicator'

interface ISaveIndicatorContext {
  saveStatus: SaveIndicatorStatus
  setSaveStatus: React.Dispatch<React.SetStateAction<SaveIndicatorStatus>>
}

const saveIndicatorContext = createContext<ISaveIndicatorContext>({} as ISaveIndicatorContext)

export const useSaveIndicatorContext = () => {
  return useContext(saveIndicatorContext)
}

export const SaveIndicatorContextProvider: React.FC = ({ children }) => {
  const [saveStatus, setSaveStatus] = useState<SaveIndicatorStatus>(undefined)
  const saveIndicatorValue = useMemo(() => ({ saveStatus, setSaveStatus }), [saveStatus, setSaveStatus])

  return createElement(saveIndicatorContext.Provider, { value: { ...saveIndicatorValue } }, children)
}
